import { render, staticRenderFns } from "./1.vue?vue&type=template&id=561db7ce&scoped=true"
import script from "./1.vue?vue&type=script&lang=js"
export * from "./1.vue?vue&type=script&lang=js"
import style0 from "./1.vue?vue&type=style&index=0&id=561db7ce&prod&lang=less&scoped=true"
import style1 from "./1.vue?vue&type=style&index=1&id=561db7ce&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561db7ce",
  null
  
)

export default component.exports